import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedGPA4to5 from "./SharedGPA4to5";
import SharedGPA5to4 from "./SharedGPA5to4";
const TITLE = "Konversi dan Hitung IPK dari 4 ke 5 dan Sebaliknya";
const DESCRIPTION =
  "Hitung IPK antara skala 4 dan 5 poin dan sebaliknya dengan mudah menggunakan kalkulator ini. Pelajari cara menghitung IPK antara skala 4 dan 5 poin dengan akurat.";
const KEYWORDS =
  "hitung IPK dari 4 ke 5, kalkulator IPK, hitung IPK dari 4 ke 5, hitung IPK sebaliknya";
const OG_URL = "https://do-calculate.com/calculator/id/gpa4to5";
function GPA4() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <p>
                  Kalkulator ini memungkinkan Anda untuk mengkonversi dan menghitung IPK dari skala 4 ke 5 poin atau mengkonversi IPK dari 5 ke 4 dengan mudah dan akurat. Jika Anda seorang mahasiswa atau lulusan dan perlu menyetarakan IPK (GPA) untuk melamar ke universitas, beasiswa, atau pekerjaan, Anda dapat menggunakan alat ini untuk menghitung IPK dengan cepat dan tanpa kesalahan.
                </p>

                <p>
                  Kalkulator IPK ini membantu Anda mengetahui cara menghitung IPK dari 4 ke 5 dan sebaliknya menggunakan rumus yang diakui, di mana IPK dikalikan atau dibagi sesuai dengan sistem penilaian yang digunakan di universitas Anda. Anda juga dapat memverifikasi kebenaran konversi IPK sebelum mengirimkan dokumen resmi Anda.
                </p>

                <p>
                  Baik Anda mencari cara mengkonversi IPK dari sistem 4.0 ke 5.0 atau ingin menghitung IPK sebaliknya, alat ini memberikan solusi tercepat dan paling akurat dengan memasukkan IPK saat ini dan mendapatkan hasil secara instan.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGPA4to5 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to4 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Tabel Konversi IPK dari 4 ke 5 dan Sebaliknya
                    </h2>{" "}
                  </u>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>Skala 4.0</th>
                        <th>Skala 5.0</th>
                      </tr>
                      <tr>
                        <td>3.97 ~ 4.0</td>
                        <td>4.95 ~ 5.00</td>
                      </tr>
                      <tr>
                        <td>3.92 ~ 3.96</td>
                        <td>4.90 ~ 4.94</td>
                      </tr>
                      <tr>
                        <td>3.88 ~ 3.91</td>
                        <td>4.84 ~ 4.89</td>
                      </tr>
                      <tr>
                        <td>3.84 ~ 3.87</td>
                        <td>4.79 ~ 4.83</td>
                      </tr>
                      <tr>
                        <td>3.80 ~ 3.83</td>
                        <td>4.73 ~ 4.78</td>
                      </tr>
                      <tr>
                        <td>3.75 ~ 3.79</td>
                        <td>4.68 ~ 4.72</td>
                      </tr>
                      <tr>
                        <td>3.71 ~ 3.74</td>
                        <td>4.62 ~ 4.67</td>
                      </tr>
                      <tr>
                        <td>3.67 ~ 3.70</td>
                        <td>4.57 ~ 4.61</td>
                      </tr>
                      <tr>
                        <td>3.62 ~ 3.66</td>
                        <td>4.51 ~ 4.56</td>
                      </tr>
                      <tr>
                        <td>3.58 ~ 3.61</td>
                        <td>4.45 ~ 4.50</td>
                      </tr>
                      <tr>
                        <td>3.49 ~ 3.57</td>
                        <td>4.34 ~ 4.44</td>
                      </tr>
                      <tr>
                        <td>3.41 ~ 3.48</td>
                        <td>4.23 ~ 4.33</td>
                      </tr>
                      <tr>
                        <td>3.32 ~ 3.40</td>
                        <td>4.12 ~ 4.22</td>
                      </tr>
                      <tr>
                        <td>3.24 ~ 3.31</td>
                        <td>4.01 ~ 4.11</td>
                      </tr>
                      <tr>
                        <td>3.15 ~ 3.23</td>
                        <td>3.90 ~ 4.00</td>
                      </tr>
                      <tr>
                        <td>3.07 ~ 3.14</td>
                        <td>3.79 ~ 3.89</td>
                      </tr>
                      <tr>
                        <td>2.98 ~ 3.06</td>
                        <td>3.68 ~ 3.78</td>
                      </tr>
                      <tr>
                        <td>2.90 ~ 2.97</td>
                        <td>3.57 ~ 3.67</td>
                      </tr>
                      <tr>
                        <td>2.81 ~ 2.89</td>
                        <td>3.45 ~ 3.56</td>
                      </tr>
                      <tr>
                        <td>2.72 ~ 2.80</td>
                        <td>3.34 ~ 3.44</td>
                      </tr>
                      <tr>
                        <td>2.64 ~ 2.71</td>
                        <td>3.23 ~ 3.33</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;